import { FaAddressCard } from 'react-icons/fa'
import s from './ContactDetailCellRenderer.scss'

const ContactDetailCellRenderer = ({ data, toggleModal }) => {
  if (!data) return null
  return (
    <span className={s.infoContainer} onClick={() => toggleModal(data.id)}>
      <FaAddressCard />
    </span>
  )
}

export default ContactDetailCellRenderer
